<ng-container *transloco="let t">
  <div class="main-content">
    <div class="topbar"></div>
    <div class="settings-main-card">
      <div class="settings-sidebar">
        @for (section of dataSections; track section.id) {
          <div
            class="section-button"
            [class.active]="section.id == activeSection"
            pRipple
            (click)="activeSection = section.id"
          >
            <span class="material-symbols-outlined section-icon">
              {{ section.icon }}
            </span>
            <span class="section-label">{{ t(section.title) }}</span>
          </div>
        }
      </div>
      <div class="settings-section">
        @for (card of currentSectionCards; track $index) {
          <div class="settings-card">
            <h2 class="card-title" [innerHTML]="t(card.title)"></h2>
            @if (card.subtitle) {
              <p class="card-subtitle" [innerHTML]="t(card.subtitle)"></p>
            }

            <ng-container
              [ngTemplateOutlet]="card.template"
              [ngTemplateOutletContext]="{ card: card }"
            >
            </ng-container>
            @if (card.showFormButtons ?? true) {
              <div class="buttons-row">
                @if (card.isEditing) {
                  <p-button
                    [label]="t('cancel')"
                    class="cancel-button"
                    icon="pi pi-undo"
                    severity="secondary"
                    (click)="cardCancelEdits(card)"
                  />

                  <p-button
                    [label]="t('save')"
                    class="save-button"
                    icon="pi pi-save"
                    [disabled]="
                      card.form?.invalid ||
                      (card.validatorFn && !card.validatorFn(card.data))
                    "
                    (click)="cardSaveEdits(card)"
                    [loading]="card.isLoading"
                  />
                } @else {
                  <p-button
                    [label]="t('edit')"
                    class="edit-button"
                    icon="pi pi-pencil"
                    severity="secondary"
                    (click)="cardEnableEdit(card)"
                    [loading]="card.isLoading"
                  />
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <ng-template #viewMapSettings let-card="card">
    {{ loadForm(card, form) }}
    <form #form="ngForm" class="fields-container">
      <p-floatlabel variant="in">
        <p-inputnumber
          inputId="default-lat"
          name="defaultLat"
          [(ngModel)]="card.data.defaultLat"
          autocomplete="off"
          [minFractionDigits]="6"
          [maxFractionDigits]="6"
          [min]="-90"
          [max]="90"
          required
          [disabled]="!card.isEditing || card.isLoading"
        />
        <label for="default-lat">
          {{ t("defaultLat") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <p-floatlabel variant="in">
        <p-inputnumber
          inputId="default-lng"
          name="defaultLng"
          [(ngModel)]="card.data.defaultLng"
          autocomplete="off"
          [minFractionDigits]="6"
          [maxFractionDigits]="6"
          [min]="-180"
          [max]="180"
          required
          [disabled]="!card.isEditing || card.isLoading"
        />
        <label for="default-lng">
          {{ t("defaultLng") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>
    </form>
  </ng-template>
</ng-container>
